import { render, staticRenderFns } from "./CreateSamplesFromDetections.vue?vue&type=template&id=49f55bc2&"
import script from "./CreateSamplesFromDetections.vue?vue&type=script&lang=js&"
export * from "./CreateSamplesFromDetections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports